import { addYears, endOfYear, startOfYear, subYears } from 'date-fns'

export const minDateDefault = subYears(startOfYear(new Date()), 60)
export const maxDateDefault = addYears(endOfYear(new Date()), 1)
